import { render, staticRenderFns } from "./Relations.vue?vue&type=template&id=df948e72"
import script from "./Relations.vue?vue&type=script&lang=js"
export * from "./Relations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports